<template>
  <div class="content-wrapper remove_table_shadow">
    <div v-if="this.active != 1" class="mb-2">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item v-if="this.active < 3"> <a href="" @click.prevent="previous">List</a></el-breadcrumb-item>
        <el-breadcrumb-item>View</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-form v-if="active === 1">
      <app-table
        :id="tableId"
        :options="options"
        @action="getListAction"
      />
    </el-form>
    <el-form v-if="active === 2">
      <div class="row">
        <div class="col-12 custom-scrollbar" style="overflow-y: scroll;height: 67vh;">
          <form-preview :id="id" :taskId="task_id" :active="{ active }"></form-preview>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import CoreLibrary from "../../../../core/helpers/CoreLibrary";
import * as actions from "../../../Config/ApiUrl";
import { TableHelpers } from "../Demo/Tables/mixins/TableHelpers";
// import AppFunction from "../core/helpers/app/AppFunction";
import AppFunction from "../../../../core/helpers/app/AppFunction";
import { axiosGet, axiosPost } from "../../../Helpers/AxiosHelper.js";
import { Input } from "element-ui";

export default {
  extends: CoreLibrary,
  name: "DatatableWithFilter",
  mixins: [TableHelpers],
  data() {
    return {
      active: 1,
      id: 0,
      task_id: 0,
      packages: {},
      isAddEditModalActive: false,
      deleteConfirmationModalActive: false,
      deleteLoader: false,
      selectedUrl: "",
      tableId: "advance-table",
      rowData: {},
      input: {},
      options: {
        name: "AdvanceTable",
        url: actions.SUBMITED_QUESTIONNAIRES,
        // url: actions.DATATABLE_DATA,
        showHeader: true,
        columns: [
          {
            title: this.$t("name"),
            type: "custom-html",
            key: "submited_questionnaire",
            modifier: (value) => {
              let name;
              if (value.length > 0) {
                name = value.map((data) => {
                  return data.form[0].name;
                });
                return `<span>${this.$t(name)}</span>`;
              }
            },
          },
          {
            title: this.$t("description"),
            type: "custom-html",
            key: "submited_questionnaire",
            modifier: (value) => {
              let description;
              if (value.length > 0) {
                description = value.map((data) => {
                  return data.form[0].description;
                });
                return `<span>${this.$t(description)}</span>`;
              }
            },
          },
          {
            title: this.$t("status"),
            type: "custom-html",
            key: "submited_questionnaire",
            modifier: (value) => {
              let status;
              if (value.length > 0) {
                status = value.map((data) => {
                  return data.pivot.status == 2 ? 'submited' : 'pending';
                });
                return `<span class="badge badge-sm badge-pill badge-success">${this.$t(status)}</span>`;
              }
            },
          },
        ],
        actions: [
          // {
          //   title: this.$t("edit"),
          //   icon: "edit",
          //   type: "none",
          //   component: "app-add-modal",
          //   modalId: "demo-add-edit-Modal",
          // },
          // {
          //   title: this.$t("delete"),
          //   icon: "trash",
          //   type: "none",
          //   component: "app-confirmation-modal",
          //   modalId: "demo-delete",
          // },
          {
            title: this.$t("view"),
            icon: "eye",
            type: "none",
            component: "app-add-modal",
            modalId: "demo-add-edit-Modal",
          },
        ],
        filters: [
          // {
          //     "title": this.$t('date'),
          //     "type": "range-picker",
          //     "key": "date",
          //     "option": ["today", "thisMonth", "last7Days", "nextYear"]
          // },
          // {
          //     "title": this.$t('age'),
          //     "type": "range-filter",
          //     "key": "age-range",
          //     "maxTitle": this.$t('max_age'),
          //     "minTitle": this.$t('min_age'),
          //     "sign": ""
          // },
          // {
          //     "title": this.$t('status'),
          //     "type": "checkbox",
          //     "key": "status",
          //     "option": [
          //         {id: 'active', value: 'Active'},
          //         {id: 'inactive', value: 'Inactive'},
          //         {id: 'invited', value: 'Invited'},
          //     ],
          // },
          // {
          //     "title": this.$t('gender'),
          //     "type": "radio",
          //     "key": "filter-with-gender",
          //     "option": [
          //         {id: 'male', value: 'Male'},
          //         {id: 'female', value: 'Female'},
          //         {id: 'other', value: 'Other'},
          //     ],
          //     "header": {
          //         "title": this.$t('want_to_filter_your_list'),
          //         "description": this.$t('you_can_filter_your_data_table_which_are_created_based_on_gender'),
          //     },
          // },
          // {
          //     "title": this.$t('search_and_select'),
          //     "type": "drop-down-filter",
          //     "key": "search select",
          //     "option": [],
          // }
        ],
        showFilter: true,
        showSearch: true,
        showCount: true,
        showClearFilter: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "default",
      },
    };
  },
  created() {
    this.options.columns = [...this.options.columns, this.actionObj];
  },
  mounted() {
    // this.getPackages();
    var company_id = this.$store.state.userCompanyProfile.dataProfile.company_id;
    if (company_id != null) {
      this.options.url = actions.SUBMITED_QUESTIONNAIRES+'/' + company_id;
    }
    setTimeout(() => {
      $( ".remove_table_shadow .h-100 .datatable .table-responsive " ).removeClass("shadow");
    }, 1000);
  },
  methods: {
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;

      if (actionObj.title == this.$t("view")) {
        // this.buyerCertificate(rowData.id);
        this.active = 2;
        this.task_id = rowData.id;
        this.id = rowData.submited_questionnaire[0].id;
      }
    },
    previous() {
        this.active = 1;
    },
  },
};
</script>
<style scoped>
.remove_table_shadow .h-100 .datatable .table-responsive {
  box-shadow: none !important;
}
</style>
